// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"373":"a743d25a","463":"a66f596a","536":"d8873056","614":"19816cdf","747":"e192645c","787":"251c225c"}[chunkId] + ".chunk.js";
};